import MyAddressesPage from './MyAddressesPage';

export default MyAddressesPage;
